import { loadDefaultJapaneseParser } from "budoux";
const parser = loadDefaultJapaneseParser();
const textBodyStyle = {
  display: "inline-block",
};
export const useBudouX = () => {
  const parse = (text) => {
    return parser.parse(text).map((s, index) => (
      <span key={index} style={textBodyStyle}>
        {s}
      </span>
    ));
  };
  return {
    parse,
  };
};
